import { SVG } from './SVG';
const IconSecondOpinion = ({ className, style, width, height, showBoxShadow = true }) => {
  const borderRadius = Math.min(width, height) * 0.25;
  const lineStyles = { stroke: 'white', strokeMiterlimit: '10', strokeLinecap: 'round', strokeLinejoin: 'round' };

  return (
    <div
      style={{
        background: 'linear-gradient(225deg, #715A9C 0%, #89558E 100%)',
        ...(showBoxShadow
          ? {
              boxShadow:
                '0px 50px 40px rgba(0, 0, 0, 0.07), 0px 20.8888px 16.711px rgba(0, 0, 0, 0.0503198), 0px 11.1682px 8.93452px rgba(0, 0, 0, 0.0417275), 0px 6.26078px 5.00862px rgba(0, 0, 0, 0.035), 0px 3.32505px 2.66004px rgba(0, 0, 0, 0.0282725), 0px 1.38363px 1.1069px rgba(0, 0, 0, 0.0196802)',
            }
          : {}),

        borderRadius,
        width,
        minWidth: width + 'px',
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      className={className}
    >
      <SVG
        width={(34 / 52) * width}
        height={(34 / 52) * height}
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'relative', left: '1px' }}
      >
        <path
          d="M30.9273 21.2716C34.2223 16.0646 33.5886 9.09395 29.0264 4.55882C23.746 -0.690179 15.1706 -0.690179 9.84799 4.55882C4.5676 9.80781 4.5676 18.3742 9.84799 23.6232C14.4102 28.2003 21.4226 28.7882 26.6607 25.5128L31.6454 26.2267L30.9273 21.2716Z"
          {...lineStyles}
        />
        <path
          d="M14.4601 19.3927C11.3993 16.3502 6.43725 16.3502 3.42289 19.3927C0.779536 22.0204 0.408539 26.031 2.3099 29.0274L1.89253 31.8856L4.76776 31.4707C7.78211 33.3607 11.8167 32.992 14.4601 30.4104C17.5208 27.3679 17.5208 22.4353 14.4601 19.3927Z"
          fill="url(#paint0_linear)"
          {...lineStyles}
        />
        <path
          d="M12.1878 25.7084C12.6488 25.7084 13.0225 25.3369 13.0225 24.8786C13.0225 24.4203 12.6488 24.0488 12.1878 24.0488C11.7268 24.0488 11.353 24.4203 11.353 24.8786C11.353 25.3369 11.7268 25.7084 12.1878 25.7084Z"
          {...lineStyles}
        />
        <path
          d="M5.69534 25.7084C6.15636 25.7084 6.53008 25.3369 6.53008 24.8786C6.53008 24.4203 6.15636 24.0488 5.69534 24.0488C5.23432 24.0488 4.8606 24.4203 4.8606 24.8786C4.8606 25.3369 5.23432 25.7084 5.69534 25.7084Z"
          {...lineStyles}
        />
        <path
          d="M8.94192 25.7084C9.40294 25.7084 9.77667 25.3369 9.77667 24.8786C9.77667 24.4203 9.40294 24.0488 8.94192 24.0488C8.48091 24.0488 8.10718 24.4203 8.10718 24.8786C8.10718 25.3369 8.48091 25.7084 8.94192 25.7084Z"
          {...lineStyles}
        />
        <path
          d="M24.3796 11.8652H21.676V9.17773C21.676 8.88379 21.4226 8.63184 21.1269 8.63184H17.7474C17.4517 8.63184 17.1983 8.88379 17.1983 9.17773V11.8652H14.4947C14.199 11.8652 13.9456 12.1172 13.9456 12.4111V15.7705C13.9456 16.0644 14.199 16.3164 14.4947 16.3164H17.1983V19.0039C17.1983 19.2978 17.4517 19.5497 17.7474 19.5497H21.1269C21.4226 19.5497 21.676 19.2978 21.676 19.0039V16.3164H24.3796C24.6753 16.3164 24.9288 16.0644 24.9288 15.7705V12.4111C24.9288 12.1172 24.6753 11.8652 24.3796 11.8652Z"
          {...lineStyles}
        />
        <defs>
          <linearGradient id="paint0_linear" x1="36.1078" y1="5.68109" x2="2.52286" y2="40.1422" gradientUnits="userSpaceOnUse">
            <stop stopColor="#615DA6" />
            <stop offset="1" stopColor="#835692" />
          </linearGradient>
        </defs>
      </SVG>
    </div>
  );
};

export { IconSecondOpinion as default, IconSecondOpinion };
